import React, { Fragment, useState, useEffect } from 'react';

import { getIndentClass } from '../../utils/styleUtils';

import RevenueRow from './RevenueRow';

import ChevronDownIcon from 'Assets/icons/chevron-down.svg';
import ChevronUpIcon from 'Assets/icons/chevron-up.svg';

export default function RevenueCostcenterRow(props) {
    const [showCostCenter, setShowCostCenter] = useState(false);

    // Handle expand all trigger from parent with staggered updates
    useEffect(() => {
        const t = props.expandAllTrigger;
        if (!t?.version) return;

        if (t.batch === 'costcenters') {
            setShowCostCenter(t.expanded);
        }
    }, [props.expandAllTrigger?.version]);

    // Calculate indentation level (Cost center is level 1)
    const indentLevel = props.indentLevel;
    const childIndentLevel = indentLevel + 1;

    const { costcenter, editingRevenueId, periods, maxRevenueMilestonesCount = 3, expandAllTrigger, ...restProps } = props;

    return (
        <>
            <tr className="!tw-bg-blue-100">
                <td className="tw-font-bold tw-cursor-pointer !tw-border-r-0" onClick={() => setShowCostCenter(!showCostCenter)}>
                    <div className={`tw-flex tw-items-center tw-gap-x-1.5 ${getIndentClass(indentLevel)}`}>
                        <div className="!tw-text-blue">{costcenter.name}</div>
                        <div>{showCostCenter ? <ChevronUpIcon /> : <ChevronDownIcon />}</div>
                    </div>
                </td>
                <td className="tw-p-4 !tw-border-x-0"></td>
                <td className="tw-font-bold tw-cursor-pointer tw-border-r-2" onClick={() => setShowCostCenter(!showCostCenter)}></td>
                <td
                    colSpan={maxRevenueMilestonesCount * 2 + 3}
                    className="tw-font-bold tw-cursor-pointer !tw-border-l-0"
                    onClick={() => setShowCostCenter(!showCostCenter)}
                ></td>
            </tr>
            {showCostCenter && (
                <Fragment>
                    {costcenter.revenues &&
                        costcenter.revenues.length > 0 &&
                        costcenter.revenues.map((revenue) => (
                            <RevenueRow
                                {...restProps}
                                key={`revenue_${revenue.id}`}
                                revenue={revenue}
                                editingRevenueId={editingRevenueId}
                                periods={periods}
                                maxRevenueMilestonesCount={maxRevenueMilestonesCount}
                                indentLevel={childIndentLevel}
                                expandAllTrigger={expandAllTrigger}
                            />
                        ))}
                </Fragment>
            )}
        </>
    );
}
